import { AXIOS } from "@/AXIOS/http-common";

const state = {
  listAllContractors: [],
  listContractors: [],
  listContractorsByEgr: [],
};

const urlPrefix = "contractor";

const actions = {
  async getAllContractors(context, data) {
    return await AXIOS.get(
      urlPrefix + "/list?page=" + data.page + "&size=" + data.size
    ).then((response) => {
      //console.log(response.data);
      context.commit("setListAllContractors", response.data);
    });
  },

  async searchContractorsByName(context, data) {
    return await AXIOS.get(
      urlPrefix +
        "/search/name?searchedSegment=" +
        data.query +
        "&page=" +
        data.page +
        "&size=" +
        data.size
    ).then((response) => {
      console.log(response.data);
      context.commit("setListAllContractors", response.data);
    });
  },

  async searchContractorsByEGR(context, data) {
    return await AXIOS.get(
      urlPrefix +
        "/search/egr?searchedSegment=" +
        data.query +
        "&page=" +
        data.page +
        "&size=" +
        data.size
    ).then((response) => {
      console.log(response.data);
      context.commit("setListContractorsByEgr", response.data);
    });
  },

  // Контрагенты с действующим на дату договором (date - YYYY-MM-DD)
  async getContractorsByDate(context, date) {
    return await AXIOS.get(urlPrefix + "/listByDate?date=" + date).then(
      (response) => response.data
    );
  },

  async getListContractors(context, params = {}) {
    const { wasteId, date } = params;
    
    let response;
    
    if (date) {
      response = await AXIOS.post(`${urlPrefix}/list/for/form/by-date`, {
        wasteId: wasteId,
        dates: [date],
      });
    } else {
      const url = wasteId 
        ? `${urlPrefix}/list/for/form?wasteId=${wasteId}` 
        : `${urlPrefix}/list/for/form`;
      response = await AXIOS.get(url);
    }
    
    console.log(response.data);
    context.commit("setListContractors", response.data);
  },

  async createContractor(context, data) {
    return await AXIOS.post(urlPrefix + "/create", data);
  },

  async updateContractor(context, data) {
    return await AXIOS.post(urlPrefix + "/update", data);
  },

  async deleteContractor(context, id) {
    return await AXIOS.get(urlPrefix + "/delete?contractorId=" + id);
  },
};

const mutations = {
  setListAllContractors(state, data) {
    state.listAllContractors = data;
  },

  setListContractors(state, data) {
    state.listContractors = data;
  },

  setListContractorsByEgr(state, data) {
    state.listContractorsByEgr = data;
  },
};

const getters = {
  GETLISTCONTRACTORS: (state) => state.listAllContractors,
  GETLISTCONTRACTORSSELECT: (state) => state.listContractors,
  GETLISTCONTRACTORSBYEGR: (state) => state.listContractorsByEgr,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
